import type { FC } from 'react';
import { useTranslation } from 'next-i18next';
import { gamesMapper, selectCouponGameBlocksCasino, selectCouponGameBlocksCasinoTotal, selectCouponGameBlocksLiveCasino, selectCouponGameBlocksLiveCasinoTotal } from '@mwl/core-lib';
import CasinoIcon from '@public/assets/common/icons/casinoGamesBlock.svg';
import LiveCasinoIcon from '@public/assets/common/icons/liveCasinoGamesBlock.svg';
import { Button } from '@/components/Button/Button';
import { GameCard } from '@/components/GameCard/GameCard';
import { routes } from '@/constants';
import { useTypedSelector } from '@/hooks';
import type { GameSelectors, SportBlockTitles, SportGamesBLock } from './SportGamesBlock.types';
import styles from './SportGamesBlock.module.scss';
const titleData: SportBlockTitles = {
  casino: {
    TitleIcon: CasinoIcon,
    title: [`sport_games_block.title.casino`, 'Casino'],
    allGamesHref: routes.casino.home
  },
  live_casino: {
    TitleIcon: LiveCasinoIcon,
    title: [`sport_games_block.title.live_casino`, 'LIVE casino'],
    allGamesHref: routes.liveCasino.home
  }
};
const gameSelectors: GameSelectors = {
  casino: {
    games: selectCouponGameBlocksCasino,
    totalElements: selectCouponGameBlocksCasinoTotal
  },
  live_casino: {
    games: selectCouponGameBlocksLiveCasino,
    totalElements: selectCouponGameBlocksLiveCasinoTotal
  }
};
const SportGamesBlock: FC<SportGamesBLock> = ({
  productType = 'casino'
}) => {
  const {
    t
  } = useTranslation('sport');
  const gamesData = useTypedSelector(gameSelectors[productType].games);
  const totalElements = useTypedSelector(gameSelectors[productType].totalElements);
  const {
    TitleIcon,
    title,
    allGamesHref
  } = titleData[productType];
  if (!gamesData?.length) {
    return null;
  }
  const games = gamesMapper(gamesData, 'small');
  return <div className={cn(styles.root)} data-sentry-component="SportGamesBlock" data-sentry-source-file="SportGamesBlock.tsx">
      <div className={styles.header}>
        <div className={styles.titleContainer}>
          <TitleIcon data-sentry-element="TitleIcon" data-sentry-source-file="SportGamesBlock.tsx" />
          <h4 className={styles.title}>{t(title)}</h4>
          {!!totalElements && <span className={styles.totalElements}>{totalElements}</span>}
        </div>

        <Button as="link" href={allGamesHref} className={styles.allGamesButton} variant="text" color="grey-light" data-sentry-element="Button" data-sentry-source-file="SportGamesBlock.tsx">
          {t('sport_games_block.all_games', 'All games')}
        </Button>
      </div>

      <div className={styles.gamesContainer}>
        {games.map(({
        hasDemoMode,
        minBet,
        maxBet,
        ...game
      }) => <div className={styles.gameCardWrapper} key={game.id}>
            <GameCard className={styles.sportCardBlock} withBadges={false} {...game} />
          </div>)}
      </div>
    </div>;
};
export * from './SportGamesBlock.types';
export { SportGamesBlock };